import * as _ from 'lodash';
import * as moment from 'moment';

import { momentFormat } from '../../common/constants';
import { ResultsStatus } from '../../models/enum';
import { NotificationType } from '../../models/Notication';
import { INotificationViewModel } from './INotificationViewModel';

export function getNotifificationDataTable(notificationViewModels: INotificationViewModel[]): string[][] {
    const result: string[][] = [];
    result.push(['Application', 'Message', 'Type', 'Timestamp', 'Status']);
    const body = notificationViewModels.map(nvm => {
        return [
            nvm.applicationName,
            nvm.messages.join('\r\n'),
            _.startCase(NotificationType[nvm.type]),
            moment(nvm.notificationDate).format(momentFormat + ':ss'),
            ResultsStatus[nvm.status]
        ];
    });
    result.push(...body);
    return result;
}